import Container from '@mui/material/Container';
import React from 'react';
import ErrorBanner from '../components/ErrorBanner';

const PageNotFound = () => {
  return (
    <>
      <ErrorBanner />
      <Container component="main" data-testid="pagenotfound-main">
        Page not found
      </Container>
    </>
  );
};

export default PageNotFound;
